<div *ngIf="!isDeleting">
    <div style="max-height: 200px; overflow-x:hidden; overflow-y: auto;">
        <div class="row pb-2" *ngFor="let f of fileList.items">
            <div class="truncate" [ngClass]="isDateShown ? 'col-7' : 'col-9'">
                <span *ngIf="f.isUploading">{{f.fileName}}</span>
                <a href="javascript:void(0)" (click)="downloadFile(f)" *ngIf="!f.isUploading">{{f.fileName}}</a>
            </div>
            <div class="col-2" *ngIf="isDateShown">{{f.dateCreated | date:"dd/MM/yyyy" }}</div>
            <div class="col-1">
                <div *ngIf="f.isUploading" class="pl-2"><i class="fas fa-spinner fa-spin fa-lg"
                        title="Uploading..."></i>
                </div>
            </div>
            <div class="col-2">
                <div class="d-flex justify-content-end">
                    <div class="pr-2" *ngIf="isAllowComments"><a href="javascript:void(0)" (click)="editComment(f)" title="Edit Comment"><i
                                class="fas fa-edit"></i></a></div>
                    <div class="pr-2" *ngIf="f.isRemovable"><a href="javascript:void(0)" (click)="removeFile(f)"
                            title="Delete File"><i class="fas fa-trash"></i></a>
                    </div>
                </div>
            </div>
            <div *ngIf="f.comment && !f.isEditing" class="col-12"><i>{{f.comment}}</i></div>
            <div *ngIf="f.isEditing" class="col-10"><input type="text" class="form-control"
                    [(ngModel)]="f.editedCommentText"></div>
            <div *ngIf="f.isEditing" class="col-2">
                <div class="d-flex justify-content-end pt-2 ">
                    <div class="pr-2"><a href="javascript:void(0)" (click)="saveComment(f)" title="Save Comment"><i
                                class="fas fa-save fa-lg"></i></a></div>
                    <div class="pr-2"><a href="javascript:void(0)" (click)="cancelComment(f)" title="Cancel"><i
                                class="fas fa-times fa-lg"></i></a></div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="fileList.items.length==0">
            <div class="col">
                No files attached
            </div>
        </div>
    </div>
    <div class="row" *ngIf="maxCount > fileList.items.length">
        <div class="col text-right">
            <input type="file" id="drop_zone" multiple [id]="elementId" (change)="handleFileInput($event.target.files) "
                style="display: none;" [(ngModel)]="selectedFileNames" />

            <button class="btn btn-link btn-sm" (click)="openFileDialog()"
                *ngIf="isUploadButtonShown">
                <i class="fas fa-paperclip"></i>&nbsp;{{buttonText}}
            </button>

        </div>
    </div>
</div>
<div *ngIf="isDeleting">
    <div class="row">
        <div class="col alert alert-warning">
            Are you sure you want to delete <b>{{fileToDelete.fileName}}</b>?
        </div>
    </div>
    <div class="row">
            <div class="col">
                    <div class="d-flex justify-content-end">
                            <div class="pr-2"><button class="btn btn-link" (click)="confirmDelete()">Yes</button></div>
                            <div class="pr-2"><button class="btn btn-link" (click)="cancelDelete()">No</button></div>
                    </div>
            </div>
        </div>
</div>
